module.exports = __webpack_public_path__ + "1362bd54570f73a45610fcc44c130228.svg";